import { RolePurposeConstants } from "@/enums/RolePurposeConstants";
import { IProject } from "@/interfaces";
import { IRegionalProjectRole } from "@/interfaces/Project/Roles/IRegionalProjectRole";
import _ from "lodash";

export const defaultUsersForProject = (
  regionRole: IRegionalProjectRole,
  project: IProject
): string[] => {
  const userIds: string[] = [];

  _.forEach(regionRole.defaultProjectUsers, (user) => {
    if (
      user.purposes.includes(RolePurposeConstants.ProjectTeam) &&
      user.publicProjectTypeIds.includes(project.projectType) &&
      user.publicProductCategoryIds.includes(project.productCategory)
    ) {
      userIds.push(user.userId);
    }
  });

  return userIds;
};
